import { BankTable } from "../components";

export const Bank = () => {
  return (
    <>
      <BankTable />
    </>
  );
};
